<template>
  <i class="app-spinner"></i>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.app-spinner {
  -webkit-animation: spinAround 500ms infinite linear;
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  display: block;
  position: relative;
  width: 3em;
  height: 3em;
  border-width: 0.25em;
  margin: auto;
}
</style>